function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  e.exports = r(3);
}, function (e, t, r) {
  (function (e) {
    !function (e) {
      "use strict";

      var t,
          r = function () {
        try {
          if (e.URLSearchParams && "bar" === new e.URLSearchParams("foo=bar").get("foo")) return e.URLSearchParams;
        } catch (e) {}

        return null;
      }(),
          n = r && "a=1" === new r({
        a: 1
      }).toString(),
          o = r && "+" === new r("s=%2B").get("s"),
          a = !r || ((t = new r()).append("s", " &"), "s=+%26" === t.toString()),
          i = l.prototype,
          c = !(!e.Symbol || !e.Symbol.iterator);

      if (!(r && n && o && a)) {
        i.append = function (e, t) {
          b(this.__URLSearchParams__, e, t);
        }, i["delete"] = function (e) {
          delete this.__URLSearchParams__[e];
        }, i.get = function (e) {
          var t = this.__URLSearchParams__;
          return this.has(e) ? t[e][0] : null;
        }, i.getAll = function (e) {
          var t = this.__URLSearchParams__;
          return this.has(e) ? t[e].slice(0) : [];
        }, i.has = function (e) {
          return g(this.__URLSearchParams__, e);
        }, i.set = function (e, t) {
          this.__URLSearchParams__[e] = ["" + t];
        }, i.toString = function () {
          var e,
              t,
              r,
              n,
              o = this.__URLSearchParams__,
              a = [];

          for (t in o) {
            for (r = s(t), e = 0, n = o[t]; e < n.length; e++) {
              a.push(r + "=" + s(n[e]));
            }
          }

          return a.join("&");
        };
        var u = !!o && r && !n && e.Proxy;
        Object.defineProperty(e, "URLSearchParams", {
          value: u ? new Proxy(r, {
            construct: function construct(e, t) {
              return new e(new l(t[0]).toString());
            }
          }) : l
        });
        var f = e.URLSearchParams.prototype;
        f.polyfill = !0, f.forEach = f.forEach || function (e, t) {
          var r = y(this.toString());
          Object.getOwnPropertyNames(r).forEach(function (n) {
            r[n].forEach(function (r) {
              e.call(t, r, n, this);
            }, this);
          }, this);
        }, f.sort = f.sort || function () {
          var e,
              t,
              r,
              n = y(this.toString()),
              o = [];

          for (e in n) {
            o.push(e);
          }

          for (o.sort(), t = 0; t < o.length; t++) {
            this["delete"](o[t]);
          }

          for (t = 0; t < o.length; t++) {
            var a = o[t],
                i = n[a];

            for (r = 0; r < i.length; r++) {
              this.append(a, i[r]);
            }
          }
        }, f.keys = f.keys || function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push(r);
          }), d(e);
        }, f.values = f.values || function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), d(e);
        }, f.entries = f.entries || function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push([r, t]);
          }), d(e);
        }, c && (f[e.Symbol.iterator] = f[e.Symbol.iterator] || f.entries);
      }

      function l(e) {
        ((e = e || "") instanceof URLSearchParams || e instanceof l) && (e = e.toString()), this.__URLSearchParams__ = y(e);
      }

      function s(e) {
        var t = {
          "!": "%21",
          "'": "%27",
          "(": "%28",
          ")": "%29",
          "~": "%7E",
          "%20": "+",
          "%00": "\0"
        };
        return encodeURIComponent(e).replace(/[!'\(\)~]|%20|%00/g, function (e) {
          return t[e];
        });
      }

      function p(e) {
        return e.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/gi, function (e) {
          return decodeURIComponent(e);
        });
      }

      function d(t) {
        var r = {
          next: function next() {
            var e = t.shift();
            return {
              done: void 0 === e,
              value: e
            };
          }
        };
        return c && (r[e.Symbol.iterator] = function () {
          return r;
        }), r;
      }

      function y(e) {
        var t = {};
        if ("object" == _typeof(e)) {
          if (h(e)) for (var r = 0; r < e.length; r++) {
            var n = e[r];
            if (!h(n) || 2 !== n.length) throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            b(t, n[0], n[1]);
          } else for (var o in e) {
            e.hasOwnProperty(o) && b(t, o, e[o]);
          }
        } else {
          0 === e.indexOf("?") && (e = e.slice(1));

          for (var a = e.split("&"), i = 0; i < a.length; i++) {
            var c = a[i],
                u = c.indexOf("=");
            -1 < u ? b(t, p(c.slice(0, u)), p(c.slice(u + 1))) : c && b(t, p(c), "");
          }
        }
        return t;
      }

      function b(e, t, r) {
        var n = "string" == typeof r ? r : null != r && "function" == typeof r.toString ? r.toString() : JSON.stringify(r);
        g(e, t) ? e[t].push(n) : e[t] = [n];
      }

      function h(e) {
        return !!e && "[object Array]" === Object.prototype.toString.call(e);
      }

      function g(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
    }(void 0 !== e ? e : "undefined" != typeof window ? window : this);
  }).call(this, r(2));
}, function (e, t) {
  var r;

  r = function () {
    return this;
  }();

  try {
    r = r || new Function("return this")();
  } catch (e) {
    "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
  }

  e.exports = r;
}, function (e, t, r) {
  "use strict";

  r.r(t);
  r(1);
  var n = {
    enabled: !0,
    debug: !1,
    trackOnNextTick: !1,
    queryParams: {},
    loadScript: !0,
    defer: !1
  };

  function o(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function a(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? o(Object(r), !0).forEach(function (t) {
        i(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function i(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var c = function c(e) {
    var t;
    n.debug && (t = console).log.apply(t, ["VueGtm :"].concat(Array.prototype.slice.call(arguments)));
  },
      u = function u(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = window,
        n = document,
        o = n.createElement("script"),
        i = "dataLayer";

    if (r[i] = r[i] || [], r[i].push({
      event: "gtm.js",
      "gtm.start": new Date().getTime()
    }), e) {
      o.async = !0, o.defer = t.defer || !1;
      var c = new URLSearchParams(a({
        id: e
      }, t.queryParams || {}));
      o.src = "https://www.googletagmanager.com/gtm.js?".concat(c), n.body.appendChild(o);
    }
  };

  function f(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? f(Object(r), !0).forEach(function (t) {
        s(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function s(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function p(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          a = Object.keys(e);

      for (n = 0; n < a.length; n++) {
        r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (n = 0; n < a.length; n++) {
        r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  function d(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  var y = "undefined" != typeof window,
      b = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.id = t;
    }

    var t, r, o;
    return t = e, (r = [{
      key: "enabled",
      value: function value() {
        return n.enabled;
      }
    }, {
      key: "enable",
      value: function value(e) {
        n.enabled = e, y && e && !Array.from(document.getElementsByTagName("script")).some(function (e) {
          return e.src.includes("googletagmanager.com/gtm.js");
        }) && n.loadScript && u(this.id, {
          defer: n.defer,
          queryParams: n.queryParams
        });
      }
    }, {
      key: "debugEnabled",
      value: function value() {
        return n.debug;
      }
    }, {
      key: "debug",
      value: function value(e) {
        n.debug = e;
      }
    }, {
      key: "dataLayer",
      value: function value() {
        return !(!y || !n.enabled) && (window.dataLayer = window.dataLayer || []);
      }
    }, {
      key: "trackView",
      value: function value(e, t) {
        c("Dispatching TrackView", {
          screenName: e,
          path: t
        }), y && n.enabled && (window.dataLayer = window.dataLayer || []).push({
          event: "content-view",
          "content-name": t,
          "content-view-name": e
        });
      }
    }, {
      key: "trackEvent",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.event,
            r = void 0 === t ? null : t,
            o = e.category,
            a = void 0 === o ? null : o,
            i = e.action,
            u = void 0 === i ? null : i,
            f = e.label,
            s = void 0 === f ? null : f,
            d = e.value,
            b = void 0 === d ? null : d,
            h = e.noninteraction,
            g = void 0 !== h && h,
            v = p(e, ["event", "category", "action", "label", "value", "noninteraction"]);

        if (c("Dispatching event", l({
          event: r,
          category: a,
          action: u,
          label: s,
          value: b
        }, v)), y && n.enabled) {
          var m = window.dataLayer = window.dataLayer || [];
          m.push(l({
            event: r || "interaction",
            target: a,
            action: u,
            "target-properties": s,
            value: b,
            "interaction-type": g
          }, v));
        }
      }
    }]) && d(t.prototype, r), o && d(t, o), e;
  }();

  function h(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function g(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? h(Object(r), !0).forEach(function (t) {
        v(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function v(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var m = function m(e, t) {
    var r = t.vueRouter,
        n = t.ignoredViews,
        o = t.trackOnNextTick;
    return n && (n = n.map(function (e) {
      return e.toLowerCase();
    })), r.afterEach(function (t) {
      if (t.name && (!n || -1 === n.indexOf(t.name.toLowerCase()))) {
        var a = t.meta.gtm || t.name,
            i = r.options.base || "";
        i.endsWith("/") || (i += "/"), i += t.fullPath.startsWith("/") ? t.fullPath.substr(1) : t.fullPath, o ? e.nextTick(function () {
          e.gtm.trackView(a, i);
        }) : e.gtm.trackView(a, i);
      }
    }), n;
  };

  t["default"] = {
    install: function install(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      t = g(g({}, n), t), n.id = t.id, n.debug = t.debug, n.enabled = t.enabled, n.loadScript = t.loadScript, n.defer = t.defer, t.vueRouter && m(e, t), e.prototype.$gtm = e.gtm = new b(n.id), n.enabled && n.loadScript && (Array.isArray(t.id) ? t.id.forEach(function (e) {
        u(e, t);
      }) : u(t.id, t));
    }
  };
}]);